module.exports = __webpack_public_path__ + "img/SotV_Icon.3de5e20c.webp";